<template>
  <div class="main-footer-wrapper">

    <v-checkbox
      v-model="flags.isChecked"
      :rules="rules.checkbox"
      label=""
      color="#0078A7"
      value="#0078A7"
      dense
      id="disclaimer"
      v-if="!shouldHideConsent"
    >
      <template v-slot:label>
        <p class="check-disclaimer" v-html="isSingleMemberLLC ? 'I agree that I am the sole beneficial owner and controller or manager.':
          `I understand that by clicking ‘continue’ I certify that I have significant responsibility to control, <br /> manage and direct the business`
          "></p>
      </template>
    </v-checkbox>

    <div v-if="errMsg" class="error-wrapper">
      <img alt="error-icon" src="../../../RF_assets/icons/error-svg.svg" />
      <p class="footer-error" v-html="errMsg"></p>
    </div>

    <div class="partner-business-footer-wrapper">
      <h3
        v-if="!isMultiBusinessFlow"
        @click="handleBack"
        class="form-footer-back -helper--flex align-center"
        id="elNavBackDesktop"
      >
        {{ $t('navBack') }}
      </h3>
      <v-btn
        class="main-app-cta active-cta"
        elevation="0"
        @click.prevent="preSubmit"
        :disabled="!customerData.incomeType.enum"
        :loading="isLoading"
        type="submit"
        id="elCta"
      >
        {{ $t('submit') }}
      </v-btn>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ActionFooter',
  props: ['isLoading', 'errMsg'],
  methods: {
    preSubmit () {
      this.$emit('onsubmit')
    },
    handleCheck () {
      this.flags.isChecked = !this.flags.isChecked
    },
    handleBack () {
      this.$store.commit('onboarding/setKeyValue', {
        prop: 'editMode',
        value: true
      })
      this.$router.push({name: 'partner-welcome', query: {token: this.partnerToken}})
    }
  },
  data () {
    return {
      flags: {
        isChecked: false
      },
      rules: {
        checkbox: [v => !!v || '']
      }
    }
  },
  computed: {
    customerData () {
      return this.$store.getters['customer/data']
    },
    isSingleMemberLLC () {
      return this.customerData.incomeType.enum === 'LLC'
    },
    shouldHideConsent () {
      return this.customerData.incomeType.enum === 'DBA' || this.customerData.incomeType.enum === 'SSN' ||
       this.customerData.incomeType.enum === null || this.customerData.incomeType.enum === undefined
    },
    partnerToken () {
      return this.$store.getters['onboarding/partnerToken']
    },
    isMultiBusinessFlow () {
      return this.$store.getters['onboarding/isMultiBusinessFlow']
    }
  }
}
</script>

<style lang="css" scoped>

.main-footer-wrapper {
  display: flex;
  flex-direction: column;
}
.partner-business-footer-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 685px;
}
.partner-business-footer-wrapper .back-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: MetricRMedium;
  color: #1f242e;
  font-size: 16px;
}
.form-footer-back {
  margin-top: 24px;
  align-self: baseline;
  font-family: MetricRRegular;
  font-size: 16px;
  color: #161919;
}
.form-footer-back::before {
  content: url('~@/RF_assets/icons/arrow-left-blue.svg');
  margin-right: 12px;
}
.form-footer-back:hover {
  cursor: pointer;
}

label:has(.error--text) .main-footer-wrapper .check-disclaimer {
  font-family: MetricRRegular;
  font-size: 14px;
  font-weight: lighter;
  color: red !important;
}

label .main-footer-wrapper .check-disclaimer {
  font-family: MetricRRegular;
  font-size: 14px;
  font-weight: lighter;
  color: #161919;
}
.error-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.footer-error {
  font-family: MetricRRegular;
  font-size: 14px;
  font-weight: lighter;
  color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PartnerOnboarding/business-sections/ActionFooter.vue